import React from 'react';

export default function FadeOutModal(props) {
	const { isFading, show, message } = props || {};

	return <>{show && <div className={`${isFading ? 'fadeOutModal' : 'fadeInModal'}`}>{message}</div>}</>;
}
